import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import clsx from 'clsx';

/**
 * ModalScrollPanel allows large blocks of content to become scrollable when their content a defined length.
 * The length that the content needs to exceed is standardized and based upon the size of the ModalScrollPanel's parent modal.
 * To use the compoennt just wrap the desired scrollable content in a ModalScrollPanel.
 *
 */
function ModalScrollPanel(_ref) {
  let {
    children,
    className,
    ...rest
  } = _ref;
  const ref = useRef();
  const containerClassName = clsx({
    'modal-scroll-panel': true
  }, className);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "modalScrollPanel",
    className: containerClassName,
    ref: ref
  }, rest), typeof children === 'string' ? children : React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
    ref
  })));
}
export default ModalScrollPanel;